import type { InventoryItem } from '../../../types/inventory';
import type { WeightUnit } from '../../../hooks/useWeightUnit';

export type ItemTypeValue = 'finished_good' | 'roasted_bulk' | 'green_bean';

export const ITEM_TYPE_OPTIONS: { value: ItemTypeValue; short: string; label: string }[] = [
  { value: 'finished_good', short: 'FG', label: 'Finished Good' },
  { value: 'roasted_bulk', short: 'RB', label: 'Roasted Bulk' },
  { value: 'green_bean', short: 'GB', label: 'Green Bean' },
];

/** Builds the "Name - (stock unit)" label shown in the product picker for a line. */
export function buildPickerLabel(item: InventoryItem, displayUnit: WeightUnit, effectiveStock: number): string {
  if (item.itemType === 'finished_good') {
    return `${item.name} - (${effectiveStock} Pcs)`;
  }
  const value = displayUnit === 'gram' ? Math.round(effectiveStock * 1000) : effectiveStock;
  const unit = displayUnit === 'gram' ? 'g' : 'kg';
  return `${item.name} - (${value} ${unit})`;
}
